import { getSession as getSessionApi } from '@gonfalon/openapi/operations/getSession';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getSession = createQueryOptions(getSessionApi);
